const links = {
    links: [
        { name: "Home", link: "/" },
        {
            name: "Getting Started",
            link: "https://nest.l4.nitk.ac.in/docs/master/user/tutorial.html",
            isExternal: true,
        },
        { name: "Contributors", link: "/contributors" },
    ],
};
export default links;
